import { render, staticRenderFns } from "./resources-categories.vue?vue&type=template&id=438ff39a"
import script from "./resources-categories.vue?vue&type=script&lang=js"
export * from "./resources-categories.vue?vue&type=script&lang=js"
import style0 from "./resources-categories.vue?vue&type=style&index=0&id=438ff39a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports